import {DraggableObject} from '../../../base/DraggableObject';
import {SimpleRoundedRect} from '../SimpleRoundedRect';
import {StaticData} from '../../../data/StaticData';
import {IPoint} from '../../../interfaces/primitives/IPoint';
import PixiUtil from '../../../../api/render/pixi/PixiUtil';
import {HandSliderEvents} from './hand_slider/HandSliderEvents';
import {InteractionEvent} from 'pixi.js';
import {DynamicData} from '../../../data/DynamicData';

export class HandSlider extends DraggableObject
{
    private readonly background: SimpleRoundedRect;
    private cardsWidth: number = 0;
    private handWidth: number = 0;
    private handHeight: number = 0;
    private sliderHeight: number = 35;
    private sliderWidth: number = 0;
    private dragEndX: number = 0;
    private smallAlpha: number = .8;

    constructor() {
        super();
        this.background = new SimpleRoundedRect();
        this.addChild(this.background).alpha = this.smallAlpha;
    }

    private _normalizedPosition: number = 0;

    get normalizedPosition(): number {
        return this._normalizedPosition;
    }

    setSizes(handWidth: number, handHeight: number, cardsWidth: number): boolean {
        this.sliderWidth = Math.pow(handWidth, 2) / cardsWidth;
        this.background.draw(this.sliderWidth, this.sliderHeight, StaticData.sceneBorderColor, StaticData.sceneMaskRadius - 2, 2);
        this.handWidth = handWidth;
        this.cardsWidth = cardsWidth;
        this.handHeight = handHeight;
        this.background.y = handHeight - this.sliderHeight;
        this.dragEndX = this.handWidth - this.sliderWidth;
        return Math.floor(this.handWidth) > Math.ceil(this.sliderWidth);
    }

    /**
     * Ограничение перемещения внутри области перетаскивания
     * @param x - желаемая координата по горизонтали
     * @param y - желаемая координата по вертикали
     * @returns объект содержащий возможные координаты, полученные из желаемых
     */
    clampPos(x: number, y: number): IPoint {
        x = PixiUtil.clamp(0, x, this.dragEndX);
        return {x, y: 0};
    }

    /**
     * Обработчик события pointerdown
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerDown(e: InteractionEvent): void {
        super.onPointerDown(e);
        DynamicData.dragSomething = false;
    }

    /**
     * Применяем позиционирование
     * @param position - объект содержащий координаты применяемой позиции по осям
     */
    moveTo(position: IPoint): void {
        this._normalizedPosition = position.x / this.dragEndX;
        dispatchEvent(new MessageEvent(HandSliderEvents.MOVE, {data: {}}));
        super.moveTo(position);
    }

    positionUpdate() {
        this.x = this._normalizedPosition * this.dragEndX;
    }

    /**
     * Обработчик события pointerover
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOver(e: InteractionEvent): void {
        this.background.alpha = 1;
    }

    /**
     * Обработчик события pointerout
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOut(e: InteractionEvent): void {
        this.background.alpha = this.smallAlpha;
    }
}
